import React from "react";

const AddOnlinePayment = () => {
  return (
    <div>
      <div>Add Online Payment</div>
    </div>
  );
};

export default AddOnlinePayment;
